declare namespace $ {

	type $mol_check_box__title_shm_ba_filter_list_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_ba_filter_list_2 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_list['all_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_view__sub_shm_ba_filter_list_3 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_list['action_buttons'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_ba_filter_list_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_ba_filter_list_5 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_list['more'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_ba_filter_list_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_ba_filter_list_7 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_list['collapse'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_ba_filter_item__title_shm_ba_filter_list_8 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_list['item_title'] >
		,
		ReturnType< $shm_ba_filter_item['title'] >
	>
	type $shm_ba_filter_item__count_shm_ba_filter_list_9 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_list['item_count'] >
		,
		ReturnType< $shm_ba_filter_item['count'] >
	>
	type $shm_ba_filter_item__status_shm_ba_filter_list_10 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_list['status'] >
		,
		ReturnType< $shm_ba_filter_item['status'] >
	>
	type $shm_ba_filter_item__highlight_shm_ba_filter_list_11 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_list['search_query'] >
		,
		ReturnType< $shm_ba_filter_item['highlight'] >
	>
	type $shm_ba_filter_item__checked_shm_ba_filter_list_12 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_list['item_checked'] >
		,
		ReturnType< $shm_ba_filter_item['checked'] >
	>
	type $shm_ba_filter_item__exclude_shm_ba_filter_list_13 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_list['item_exclude'] >
		,
		ReturnType< $shm_ba_filter_item['exclude'] >
	>
	type $shm_ba_filter_item__only_shm_ba_filter_list_14 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_list['item_only'] >
		,
		ReturnType< $shm_ba_filter_item['only'] >
	>
	export class $shm_ba_filter_list extends $mol_view {
		all_checked( next?: boolean ): boolean
		All( ): $mol_check_box
		action_buttons( ): readonly(any)[]
		Actions( ): $mol_view
		row_views( ): readonly(any)[]
		more( next?: any ): any
		collapse( next?: any ): any
		item_title( id: any): string
		item_count( id: any): string
		status( id: any): string
		search_query( next?: string ): string
		item_checked( id: any, next?: boolean ): boolean
		item_exclude( id: any, next?: any ): any
		item_only( id: any, next?: any ): any
		table( ): any
		filter( next?: Record<string, any> ): Record<string, any>
		visible_count( next?: number ): number
		sub( ): ReturnType< $shm_ba_filter_list['row_views'] >
		More( ): $mol_button_minor
		Collapse( ): $mol_button_minor
		Item( id: any): $shm_ba_filter_item
	}
	
}

//# sourceMappingURL=list.view.tree.d.ts.map